import { ContactCard } from "dyl-components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PhoneUtil } from "utils";

const HoverContent = ({user}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user_id } = useSelector(state => ({
        user_id: state.auth.user_id
    }));

    if (!user) {
        return <div>No User Selected</div>;
    
    }
    const { id } = user;

    const onCallClick = () => {
        PhoneUtil.C2D({payload: { destination: user?.ext, to_user_id: id}, dispatch});
    }
    
    return (
        <ContactCard
            userInfo={user}
            toNavigate={() => navigate(`/settings/users/${id}/general`)}
            onEmail={null}
            onText={null}
            isInactive={!!!user.active}
            onCall={user?.ext && id !== user_id ? () => onCallClick() : null} 
            title={" "}
        />
    );
};

const hoverContent = HoverContent;

export default hoverContent;
